import React from 'react';

const ShopNameCard = ({ settings, onChange }) => (
  <div className="bg-white rounded-xl shadow p-6">
    <h3 className="font-semibold mb-4">店铺名称</h3>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div>
        <label className="block text-sm font-medium mb-1">中文名 *</label>
        <input type="text" value={settings.shop_name}
          onChange={e => onChange('shop_name', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          placeholder="台灣柑仔店" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">英文名</label>
        <input type="text" value={settings.shop_name_en}
          onChange={e => onChange('shop_name_en', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          placeholder="Taiwan Shop" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">高棉语名</label>
        <input type="text" value={settings.shop_name_km}
          onChange={e => onChange('shop_name_km', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500" />
      </div>
    </div>
  </div>
);

export default ShopNameCard;